( function( $ ) {
    /**
     * Datepicker for search functionality to/from functionality.
     */
    if($('.search-datepicker').length) {
        $('.search-datepicker').datepicker({
            maxDate: '0',
            changeYear: true,
            yearRange: "1997:+nn",
            dateFormat: 'dd-mm-yy',
            onSelect: function( selectedDate ) {
                if(this.id == 'binddatefrom' ) {
                    var dateMin = $( '#binddatefrom' ).datepicker( "getDate" );
                    var rMin = new Date( dateMin.getFullYear(), dateMin.getMonth(), dateMin.getDate() + 1 );
                    $( '#binddateto' ).datepicker( "option", "minDate", rMin );
                }

            }
        });
    }
} )( jQuery );